const Cache: Map<string | null, number> = new Map();

export default Cache;
